import React from "react";
import { Box, useTheme } from "@mui/material";
import TallyBrownLogo from "../../assets/tally-brown.png";

interface AvatarPanelProps {
  children?: React.ReactNode;
}

const AvatarPanel: React.FC<AvatarPanelProps> = () => {
  const theme = useTheme();
  const backgroundColor = theme.palette.primary.main;

  return (
    <Box
      borderRadius="50%"
      justifyContent="center"
      alignItems="center"
      display="flex"
      sx={{
        backgroundColor: backgroundColor,
        height: { xs: "1.4rem", md: "2.1rem" },
        width: { xs: "1.4rem", md: "2.1rem" },
        overflow: "hidden", // Ensure image stays within circular bounds
      }}
    >
      <Box
        component="img"
        src={TallyBrownLogo}
        alt="Tally Assistant Avatar"
        sx={{
          width: "100%", // Slightly smaller than container for padding
          height: "100%",
          objectFit: "contain", // Maintain aspect ratio
        }}
      />
    </Box>
  );
};

export default AvatarPanel;
